

































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import api from "@/api";
import uploadNew from "@/components/uploadNew.vue";
import uploads from "@/components/uploads.vue";
import { clientLink, showTagRE } from '@/utils/common'
import { imageUrl } from '@/utils/common'

@Component({
    name: "activityAdd",
    components: {
        uploadNew: uploadNew,
        uploads
    }
})

export default class extends Vue {

    canyuProduct: any = ''

    images: any = []
    fileList = {
        image_name: '', image_url: ''
    }
    model: any = {
        OSSAccessKeyId: "",
        signature: "",
        policy: "",
        key: "",
        callback: "",
        file: "",
        success_action_status: ''
    };
    baseUrl = imageUrl
    getData(item: any) {
        this.images.push(this.baseUrl + item)
    }
    delPro(key: any) {
        this.images.splice(key, 1)
    }


    // 可用机构
    showIconOrg = true
    orgList: any = []
    orgListC: any = []
    orgDialog = false
    orgData: any = []
    keyword = ''
    getOrg() {
        this.orgData = []
        api
            .post('J27716', { keyword: this.keyword, status: 1 })
            .then(res => {
                this.orgDialog = true
                this.orgData = res.list
            })
    }

    handleOrgChange(val: any) {
        this.orgList = val
    }

    sureOrg() {
        if (this.orgList.length != 0) {
            this.showIconOrg = false
            this.orgListC = [...this.orgList]
        }
        this.orgDialog = false
    }

    closeOrgDialog() {
        this.orgDialog = false
    }

    delTag(row: any) {
        this.orgListC.splice(this.orgListC.findIndex((item: any) => item.code === row.code), 1)
        // this.orgListC = [...this.orgList]
        if (this.orgListC.length == 0) {
            this.showIconOrg = true
        }
    }
    delAll() {
        // this.orgList = []
        this.orgListC = []
        this.showIconOrg = true;
        (this.$refs.table as any).clearSelection();
    }
    editOrgList() {
        this.orgList = [...this.orgListC]
        this.orgDialog = true
    }
    open() {
        api.post('J27716', { keyword: this.keyword, status: 1 })
            .then(res => {
                this.orgData = res.list


                let selected = this.orgListC;//默认要选择复选框的数据
                // (this.$refs as any).table2.clearSelection();
                (this.$refs.table as any).clearSelection();
                selected.forEach((item: any) => { // checkedData为已选数据
                    this.$nextTick(() => {
                        this.orgData.find((obj: any) => { // userData 表单数据
                            if (item.id == obj.id) {
                                (this.$refs.table as any).toggleRowSelection(obj, true);
                                // this.$forceUpdate()
                            }
                        })

                    })
                })
            })

    }

    jine1 = ''
    jine2 = ''
    form: any = {
        participateType: ''
    }

    // 标签
    tagVal = ''
    tags: any = []
    tagsC: any = []
    newTags: any = []
    delTags: any = []


    handleClose(tag: any) {
        this.delTags.push(tag)
        this.tags.splice(this.tags.indexOf(tag), 1);

    }


    sureLoading = false
    sure() {
        if (!this.form.activityName) {
            this.$message.warning('请填写活动名称')
            return
        }
        if (!this.form.activityStartTime) {
            this.$message.warning('请选择活动开始时间')
            return
        }
        if (!this.form.activityEndTime) {
            this.$message.warning('请选择活动结束时间')
            return
        }
        // 验证活动结束时间不能早于活动开始时间
        if (new Date(this.form.activityEndTime) < new Date(this.form.activityStartTime)) {
            this.$message.warning('活动结束时间不能早于活动开始时间')
            return
        }
        if (this.form.participateType === '') {
            this.$message.warning('请选择参加次数')
            return
        }

        if (this.hdType != 'SHARE_REWARD_INTEGRAL') {
            if (this.form.giveType == null) {
                this.$message.warning('请选择赠送积分类型')
                return
            }
            if (!this.form.giveQuantity) {
                this.$message.warning('请填写赠送积分数量')
                return
            }
            if (!this.canyuProduct) {
                this.$message.warning('请选择参与商品')
                return
            }
            if (this.canyuProduct == 2) {
                if (this.orgListC.length == 0) {
                    this.$message.warning('请选择参与商品')
                    return
                }
            }
            if (this.canyuProduct == 1) {
                this.form.participateProducts = '00000'
            } else if (this.canyuProduct == 2) {
                let a: any = []
                this.orgListC.forEach((item: any) => {
                    a.push(item.id)
                })

                this.form.participateProducts = a.join('@')
            }

            if (this.hdType == 'BID_BIND_INTEGRAL') {
                if (!this.form.giveTarget) {
                    this.$message.warning('请选择赠送对象')
                    return
                }
                if (!this.form.areaType) {
                    this.$message.warning('请选择活动地区/机构')
                    return
                }
                if (this.form.bidAmountLimitType == null) {
                    this.$message.warning('请选择积分限制类型')
                    return
                }
                if (this.form.bidAmountLimitType == 1) {
                    if (this.jine1 == '' && this.jine2 == '') {
                        this.$message.warning('请选择保函金额限制范围')
                        return
                    }
                    if (this.jine2 <= this.jine1) {
                        this.$message.warning('保函金额限制范围最大值不能小于最小值')
                        return
                    }
                    this.form.bidAmountRange = [this.jine1, this.jine2]
                }
                if (this.images.length == 0) {
                    this.$message.warning('请上传入口图片')
                    return
                }
                if (this.images.length > 0) {
                    this.form.entryImage = this.images[0]
                }
            }
        }else{
            if (this.form.auditType == null) {
                this.$message.warning('请选择奖励审核类型')
                return
            }
            // this.form.integralRewardEnabled == 0 && 
            if (this.form.bidBindRewardEnabled == 0 && this.form.orderRewardEnabled == 0) {
                this.$message.warning('请开启至少一种活动奖励')
                return
            }
            if(this.form.bidBindRewardEnabled && this.form.bidBindGiveType == null){
                this.$message.warning('请选择投标保函出函奖励类型')
                return
            }
            if(this.form.bidBindRewardEnabled && !this.form.bidBindGiveQuantity){
                this.$message.warning('请填写投标保函出函奖励数值')
                return
            }
            if(this.form.orderRewardEnabled && !this.form.orderGiveType == null){
                this.$message.warning('请选择下单送积分奖励类型')
                return
            }
            if(this.form.orderRewardEnabled && !this.form.orderGiveQuantity){
                this.$message.warning('请填写下单送积分奖励数值')
                return
            }
        }

        this.form.activityType = this.hdType
        this.sureLoading = true
        api
            .post(this.id ? 'J27748' : 'J27745', this.form)
            .then(res => {
                this.tags = []
                this.newTags = []
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });

                this.$router.push({
                    name: 'applet_activity_point'
                })
            }).finally(() => {
                this.sureLoading = false
            })

    }

    cancle() {
        this.$router.back()
    }


    // 编辑
    getDetail(id: any) {
        api
            .post('J27747', { id: this.id })
            .then(async (res: any) => {
                this.form = res

                if (this.form.entryImage) {
                    this.images = [this.form.entryImage]
                }

                if (this.form.bidAmountRange) {
                    this.jine1 = this.form.bidAmountRange[0]
                    this.jine2 = this.form.bidAmountRange[1]
                }


                if (this.form.participateProducts) {

                    if (this.form.participateProducts == '0000' || this.form.participateProducts == '00000') {
                        this.canyuProduct = '1'
                        return
                    }
                    this.canyuProduct = '2'
                    let a: any = []
                    let sendingOrganizationCode = this.form.participateProducts.split('@')

                    api
                        .post('J27716', this.keyword)
                        .then(res => {
                            this.orgData = res.list

                            this.orgData.forEach((row: any) => {

                                sendingOrganizationCode.forEach((item: any) => {
                                    if (row.id == item) {
                                        a.push(row)
                                    }
                                })
                            })
                            this.orgListC = a
                            this.showIconOrg = false
                        })
                }





            })
    }

    config = {
        ActivityTypeEnum: {}
    }
    getConfig() {
        api.getJavaConfig().then((res) => {
            this.config = res;
        });
    }


    id: any = ''
    showUpload = true
    hdType: any = ''
    activated() {
        this.form = { participateType: '' }
        this.images = []

        this.showIconOrg = true
        this.orgListC = []
        this.id = this.$route.query.id
        this.hdType = this.$route.query.activityType

        this.getConfig()
        if (this.id) {
            this.getDetail(this.id)

        }
        this.showUpload = false
        this.$nextTick(() => { this.showUpload = true })

    }


}
